export const MERCHANT_INVOICE_EMAIL_REQUEST = "MERCHANT_INVOICE_EMAIL_REQUEST";
export const MERCHANT_INVOICE_EMAIL_SUCCESS = "MERCHANT_INVOICE_EMAIL_SUCCESS";
export const MERCHANT_INVOICE_EMAIL_FAIL = "MERCHANT_INVOICE_EMAIL_FAIL";

export const ADMIN_GIFTCARDSEND_REQUEST = " ADMIN_GIFTCARDSEND_REQUEST";
export const ADMIN_GIFTCARDSEND_SUCCESS = " ADMIN_GIFTCARDSEND_SUCCESS";
export const ADMIN_GIFTCARDSEND_FAIL = " ADMIN_GIFTCARDSEND_FAIL";

export const CUSTOMER_ABADONEDMAIL_REQUEST = " CUSTOMER_ABADONEDMAIL_REQUEST";
export const CUSTOMER_ABADONEDMAIL_SUCCESS = " CUSTOMER_ABADONEDMAIL_SUCCESS";
export const CUSTOMER_ABADONEDMAIL_FAIL = " CUSTOMER_ABADONEDMAIL_FAIL";

export const ORDERDELAYMAIL_SEND_REQUEST = " ORDERDELAYMAIL_SEND_REQUEST";
export const ORDERDELAYMAIL_SEND_SUCCESS = " ORDERDELAYMAIL_SEND_SUCCESS";
export const ORDERDELAYMAIL_SEND_FAIL = " ORDERDELAYMAIL_SEND_FAIL";

export const ORDERPROCESSINGTIME_MAIL_SEND_REQUEST = " ORDERPROCESSINGTIME_MAIL_SEND_REQUEST";
export const ORDERPROCESSINGTIME_MAIL_SEND_SUCCESS = " ORDERPROCESSINGTIME_MAIL_SEND_SUCCESS";
export const ORDERPROCESSINGTIME_MAIL_SEND_FAIL = " ORDERPROCESSINGTIME_MAIL_SEND_FAIL";

export const CUSTOMERS_REVIEWMAIL_REQUEST = "CUSTOMERS_REVIEWMAIL_REQUEST";
export const CUSTOMERS_REVIEWMAIL_SUCCESS = "CUSTOMERS_REVIEWMAIL_SUCCESS";
export const CUSTOMERS_REVIEWMAIL_FAIL = "CUSTOMERS_REVIEWMAIL_FAIL";

export const EMAIL_SYS_LIST_REQUEST = "EMAIL_SYS_LIST_REQUEST";
export const EMAIL_SYS_LIST_SUCCESS = "EMAIL_SYS_LIST_SUCCESS";
export const EMAIL_SYS_LIST_FAIL = "EMAIL_SYS_LIST_FAIL";

export const EMAIL_SYS_INSTANT_REQUEST = "EMAIL_SYS_INSTANT_REQUEST";
export const EMAIL_SYS_INSTANT_SUCCESS = "EMAIL_SYS_INSTANT_SUCCESS";
export const EMAIL_SYS_INSTANT_FAIL = "EMAIL_SYS_INSTANT_FAIL";
